export const FREIGHT_REQUIRED_SERVICES = [{ label: 'Pickup & Delivery', value: 'cargoPickupDelivery' },
{ label: 'Port Handling', value: 'portHandling' },
{ label: 'Custom Clearance', value: 'customClearance' },
{ label: 'WareHousing', value: 'warehousing' }];

export const FREIGHT_ADDITIONAL_SERVICES = [{ label: 'Insurance', value: 'insurance' },
{ label: 'Package', value: 'package' }];
